import { Interval } from 'luxon';

import { BaseDateRangeType } from 'application-types';
import { parseDateTime } from './parseDateTime';

export function doDateRangesOverlap(
  rangeA: BaseDateRangeType,
  rangeB: BaseDateRangeType
): boolean {
  try {
    const intervalA = Interval.fromDateTimes(
      parseDateTime(rangeA.startDate)!,
      parseDateTime(rangeA.endDate)!
    );
    const intervalB = Interval.fromDateTimes(
      parseDateTime(rangeB.startDate)!,
      parseDateTime(rangeB.endDate)!
    );

    return intervalA.overlaps(intervalB);
  } catch {
    return false;
  }
}
